document.addEventListener('DOMContentLoaded', () => {
    const form = document.getElementById('frm_user_product_list');
    if (!form) {
        return;
    }

    const resetPage = () => {
        const pageInput = form.querySelector('input[name="page"]');
        if (pageInput) {
            pageInput.value = '1';
        }
    };

    const areaSelect = form.querySelector('select[name="area_id"][data-auto-submit="1"]');
    if (areaSelect) {
        areaSelect.addEventListener('change', () => {
            resetPage();
            form.submit();
        });
    }

    const orderbySelect = form.querySelector('select[name="orderby"][data-auto-submit="1"]');
    if (orderbySelect) {
        orderbySelect.addEventListener('change', () => {
            form.submit();
        });
    }

    form.querySelectorAll('.js-product-filter-toggle').forEach((button) => {
        button.addEventListener('click', () => {
            const key = button.dataset.filterKey;
            const value = button.dataset.filterValue;
            if (!key) {
                return;
            }

            const input = form.querySelector(`input[name="${key}"]`);
            if (!input) {
                return;
            }

            input.value = value ?? '0';
            form.submit();
        });
    });
});
